import { getFullUrl } from 'hubspot-url-utils';
export const generatePublicProfileUrl = userId => {
  return `${getFullUrl('app', {
    hubletOverride: 'na1'
  })}/academy-profile/member/${userId}`;
};